import { render, staticRenderFns } from "./KitCard.vue?vue&type=template&id=47497ed4&scoped=true&"
import script from "./KitCard.vue?vue&type=script&lang=js&"
export * from "./KitCard.vue?vue&type=script&lang=js&"
import style0 from "./KitCard.vue?vue&type=style&index=0&id=47497ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47497ed4",
  null
  
)

export default component.exports